import { TspType } from '@entities/tsp'
import { themeByCSSVariables } from '@shared/lib/theme'

export const getSelectDenominationButtonColor = (
  isSelected: boolean,
  tspType: TspType | undefined,
  colorSubcategory?: string
) => {
  if (isSelected) {
    if (tspType === TspType.KEYS) {
      return themeByCSSVariables.colors.background.accent_30
    }

    return `#${colorSubcategory}4d`
  }

  if (tspType === TspType.KEYS) {
    return themeByCSSVariables.colors.background.accent
  }

  return `#${colorSubcategory}`
}
